import React from 'react';
import { AverageOrderStatisticsComponent, DateFromTo } from '../../../../generated/graphql';
import { useFromToContext } from '../../../shared';
import { Placeholder } from '../Placeholder';
import { CHART_PLACEHOLDER_HEIGHT } from '../constants';
import AverageOrderStatisticsView from './AverageOrderStatisticsView';

const AverageOrderStatistics = () => {
    const { dateFromTo } = useFromToContext();

    return (
        <AverageOrderStatisticsComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={CHART_PLACEHOLDER_HEIGHT} />}
        >
            {({ data: { averageOrderStatistics } }) => (
                <AverageOrderStatisticsView averageOrderStatistics={averageOrderStatistics} />
        )}
        </AverageOrderStatisticsComponent>
    );
};

export default AverageOrderStatistics;